import {ResearchLitElement, html, css} from '@core/research-lit-element';
import {BdModal} from '@bog-design-system/bd-modal';

import '@bog-design-system/bd-font';
import '@bog-design-system/bd-pagination';
import '@bog-design-system/bd-space-description';
import '@bog-design-system/bd-select';
import '@bog-design-system/bd-dropdown-item';

import '../../common/layout/research-section';
import '../../common/faq/research-faq';
import '../../common/research-card';
import '../../common/filter/research-filter';
import '../../common/filter/research-filter-item';
import '../../common/modals/research-info-modal';
import '../../skeleton/research-skeleton';
import './components/research-catalog-methods-section';
import './components/research-catalog-filter-modal';

class researchCatalog extends ResearchLitElement {
    static get is() {
        return 'research-catalog';
    }

    static get styles() {
        return css`
            .research-background-layer {
              position: absolute;
              background: var(--color-pfm-home-background);
              -webkit-filter: blur(92px);
              filter: blur(92px);
              inset: 0 0 -280px;
              bottom: 280px;
              z-index: -1;
              height: 700px;
              width: 100%;
            }
          
            .research-background-layer-2 {
              position: absolute;
              background: var(--color-invert-background-solid-10);
              -webkit-filter: blur(92px);
              filter: blur(92px);
              bottom: -280px;
              left: 0px;
              z-index: -1;
              height: 700px;
              width: 100%;
            }
          
            .cover-section {
                display: flex;
                --section-background-color: transparent;
                padding-bottom: var(--space-64);
            }

            .header-container {
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: center;
                gap: var(--space-12);
            }

            .title h1,
            .description {
                text-align: center;
            }

            .title {
                color: var(--color-invert-component-tr-20);
            }
          
            .description {
              color: var(--color-invert-component-tr-30);
              max-width: 854px;
            }

            .faq-section {
                padding-bottom: var(--space-128);
            }

            .faq {
                --justify-title: center;
            }

            .catalog-section {
                --section-background-color: transparent;
                padding-top: 0;
            }

            .catalog-wrapper {
                display: grid;
                grid-template-columns: 306px 1fr;
                gap: var(--space-24);
            }

            .filter-container {
                display: flex;
                flex-flow: column;
                gap: var(--space-24);
            }
          
            .catalog-filter {
              --bg-color: var(--color-invert-background-solid-40);
              --border-color: var(--color-invert-component-tr-70);
            }
          
            .filter-item {
              --item-min-height: var(--space-48);
            }

            .items-container {
                display: flex;
                flex-direction: column;
                gap: var(--space-24);
            }
          
            .research-card {
              border: 1px solid var(--color-invert-component-tr-70);
            }

            .pagination-wrapper {
                padding-top: var(--space-24);
            }

            .pagination-component {
                justify-content: center;
                flex-wrap: wrap;
                gap: var(--space-16) 0;
            }

            .cards-wrapper {
                display: flex;
                flex-direction: column;
                gap: var(--space-24);
            }

            @media (max-width: 1024px) {
                .cover-section {
                    padding-top: var(--space-48);
                    padding-bottom: var(--space-48);
                }

                .catalog-section {
                    padding-bottom: var(--space-48);
                }

                .catalog-wrapper {
                    grid-template-columns: 1fr;
                }

                .responsive-filter-block {
                    display: flex;
                    flex-direction: row;
                    gap: var(--space-16);
                    justify-content: flex-end;
                }

                .select {
                    max-width: 200px;
                }

                .dropdown-item {
                    height: var(--space-40);
                }
            }

            @media (max-width: 768px) {
                .cover-section {
                    padding-top: var(--space-40);
                    padding-bottom: var(--space-40);
                }

                .header-container {
                    align-items: flex-start;
                }

                .title h1,
                .description {
                    text-align: left;
                }

                .faq-section {
                    padding-bottom: var(--space-96);
                } 
            }

            @media (max-width: 600px) {
                .title {
                  font-size: var(--space-24);
                }

                .responsive-filter-block {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                }
                
                .select {
                  --logo-size: 0;
                  --input-width: unset;
                }

                .pagination-wrapper {
                    padding-top: var(--space-16);
                }

                .catalog-section {
                    padding-bottom: var(--space-32);
                    --border-space: var(--space-16);
                }
                
                .faq-section {
                    padding-top: var(--space-32);
                    padding-bottom: var(--space-64);
                    --border-space: var(--space-16);
                }

                .faq {
                    --faq-padding: var(--space-24) var(--space-16);
                    --title-font-size: var(--space-24);
                }
            }
        `;
    }

    render() {
        return html`
            <div class="research-background-layer"></div>
            ${this.data?.header?.title ?
                html`
                      <research-section class="cover-section">
                          <div class="header-container">
                              <bd-font type="h2">
                                  <h1 class="title">${this.data.header.title}</h1>
                              </bd-font>
                              ${this.data.header?.description ?
                                  html`
                                        <bd-font type="body1" class="description">
                                            <span>${this.data.header.description}</span>
                                        </bd-font>
                                    ` :
                                  ''}
                          </div>
                      </research-section>
                  ` :
                ''}
            ${this.data?.catalog ?
                html`
                      <research-section class="catalog-section">
                          <div class="catalog-wrapper">
                              <div class="filter-container">
                                  ${this._isLaptop ?
                                      html`
                                            <div class="responsive-filter-block">
                                                <bd-standard-button
                                                    class="filter-button"
                                                    type="secondary"
                                                    dropdownicon="bd:chevron_down"
                                                    size="small"
                                                    prefix-icon="bd:filter_outline"
                                                    @click="${() => this.openModal(true, this.data?.catalog)}"
                                                >
                                                    ${this.data.catalog?.dictionary?.filterBtnLabel}
                                                </bd-standard-button>
                                                ${this.data.catalog?.sortItems?.length > 0 ?
                                                    html`
                                                        <bd-select
                                                           value=${this.sortStr}
                                                           class="select"
                                                           mode="inline"
                                                           @value-change="${(e) =>
                                                                   this._handleSortValueChange(e.detail.value)}"
                                                        >
                                                        ${this.data.catalog.sortItems.map((item)=> html`
                                                          <bd-select-item
                                                              label="${item.title}"
                                                              value="${item.tagName}"
                                                              slot="item">
                                                          </bd-select-item>
                                                        `)}
                                                        </bd-select>
                                                      ` :
                                                    ``}
                                            </div>
                                        ` :
                                      this._getFilters()}
                              </div>
                              <div class="researches-block">
                                  ${this.isLoading ?
                                      html`
                                            <div class="skeleton-container">
                                                <div class="cards-wrapper">
                                                    ${this._skeletonArr.map(
                                                        () =>
                                                            html`
                                                                <research-skeleton component="research-card-skeleton">
                                                                </research-skeleton>
                                                            `
                                                    )}
                                                </div>
                                                <div class="pagination-wrapper">
                                                    <research-skeleton component="research-pagination-skeleton">
                                                    </research-skeleton>
                                                </div>
                                            </div>
                                        ` :
                                      html`
                                            <div class="items-container">
                                                ${this.itemsToShow && this.itemsToShow.length > 0 ?
                                                    html`
                                                          <div class="cards-wrapper">
                                                              ${this.itemsToShow.map(
                                                                  (card) => html`
                                                                      <research-card
                                                                          class="research-card"
                                                                          title="${card.title}"
                                                                          description="${card.description}"
                                                                          gift-text="${card.badge}"
                                                                          duration-text="${card.duration}"
                                                                          duration-icon="bd:time_clock"
                                                                          location-text="${card.location?.value?.title || ''}"
                                                                          location-icon="${this.getIcon(card.location)}"
                                                                          device-text="${card.device?.value?.text || card.device?.value?.title || ''}"
                                                                          device-icon="${this.getIcon(card.device, true)}"
                                                                          dates-label="${this.data?.catalog?.dictionary
                                                                              ?.cardDateLabel}"
                                                                          start-date="${card.startDate || ''}"
                                                                          end-date="${card.finishDate || ''}"
                                                                          has-footer
                                                                      >
                                                                          ${this.data?.catalog?.dictionary
                                                                              ?.cardMoreButtonLabel ?
                                                                              html` <bd-standard-button
                                                                                    type="text-primary"
                                                                                    slot="more-button"
                                                                                    size="medium"
                                                                                    href="${`/${this.lang}/research/details/${card._id}`}"
                                                                                    @click="${() => {
                                                                                  this.sendAnalyticsEvent({
                                                                                      eventName: 'Research_Bog',
                                                                                      eventAction: 'catalog_detail_click',
                                                                                      eventLabel: card.title,
                                                                                      isNonInteraction: false,
                                                                                      sendToFB: true,
                                                                                      });
                                                                                  }}"
                                                                                >
                                                                                    ${this.data.catalog?.dictionary
                                                                                        .cardMoreButtonLabel}
                                                                                </bd-standard-button>` :
                                                                              ''}
                                                                          ${this.data?.catalog?.dictionary
                                                                              ?.cardRegisterButtonLabel && card.registration?.link ?
                                                                              html` <bd-standard-button
                                                                                    type="primary"
                                                                                    slot="register-button"
                                                                                    size="medium"
                                                                                    @click="${() => {
                                                                                        this.openModal(false, card.registration);
                                                                                        this.sendAnalyticsEvent({
                                                                                            eventName: 'Research_Bog',
                                                                                            eventAction: 'catalog_register_click',
                                                                                            eventLabel: card.title,
                                                                                            isNonInteraction: false,
                                                                                            sendToFB: true,
                                                                                        });
                                                                                    }}"
                                                                                >
                                                                                    ${this.data.catalog?.dictionary
                                                                                        .cardRegisterButtonLabel}
                                                                                </bd-standard-button>` :
                                                                              ''}
                                                                      </research-card>
                                                                  `
                                                              )}
                                                          </div>
                                                          <div class="pagination-wrapper">
                                                              ${this._totalItems > this._pageSize ?
                                                                  html`
                                                                        <bd-pagination
                                                                            class="pagination-component"
                                                                            page="${this._currentPage}"
                                                                            label="${this.data.catalog?.dictionary?.paginationLabel}"
                                                                            @page-change="${this._handlePageChange}"
                                                                            page-size="${this._pageSize}"
                                                                            total-count="${this._totalItems}"
                                                                            showPageInput=${false}
                                                                        >
                                                                        </bd-pagination>
                                                                    ` :
                                                                  ``}
                                                          </div>
                                                      ` :
                                                    html`
                                                          <div class="blank-items-container">
                                                              ${this.data?.catalog?.spaceDescription?.title ? html`
                                                              <bd-space-description
                                                                  icon="bd:bank_statement"
                                                                  header="${this.data.catalog.spaceDescription.title}"
                                                                  description="${this.data.catalog.spaceDescription
                                                                      .description}"
                                                                  type="illustration"
                                                                  size="${this._isMobile ? 'small' : 'medium'}"
                                                                  illustration="${this._isMobile ?
                                                                      this.data.catalog.spaceDescription.responsiveImage.url :
                                                                      this.data.catalog.spaceDescription.image.url}"
                                                                  class="space-description"
                                                              >
                                                                  ${this.data.catalog.spaceDescription.primaryLabel ? html`
                                                                  <bd-standard-button
                                                                      slot="button"
                                                                      class="space-description-btn"
                                                                      type="text-low"
                                                                      @click="${() => this._clearFilters(this)}"
                                                                  >
                                                                      ${this.data.catalog.spaceDescription.primaryLabel}
                                                                  </bd-standard-button>
                                                                  ` : ''}
                                                              </bd-space-description>
                                                              ` : ''}
                                                          </div>
                                                      `}
                                            </div>
                                        `}
                              </div>
                          </div>
                          <div class="research-background-layer-2"></div>
                      </research-section>
                  ` :
                ''}
            ${this.data?.methods?.title && this.data.methods.list?.length > 0 ?
                html`
                      <research-catalog-methods-section
                          .data="${this.data.methods}"
                      ></research-catalog-methods-section>
                  ` :
                ''}
            ${this.data.faq?.faqTitle && this.data.faq.faq?.length > 0 ?
                html`
                      <research-section class="faq-section">
                          <research-faq class="faq" stroke title-type="h2" .data="${this.data.faq}"> </research-faq>
                      </research-section>
                  ` :
                ``}
        `;
    }

    _getFilters() {
        return html`
            ${this.filtersIsLoading ?
                html`
                    <research-skeleton component="research-filter-skeleton"></research-skeleton>
                    <research-skeleton component="research-filter-skeleton"></research-skeleton>
                ` :
                html`
                      ${this.segments?.length > 0 ?
                          html`
                                <research-filter
                                    active
                                    id="catalog-filter"
                                    class="catalog-filter"
                                    title="${this.data.catalog?.dictionary?.segmentsLabel}"
                                    ._selected="${this._filterSegment}"
                                    @filter-changed="${this._handleChangedSegment}"
                                >
                                    ${this.segments.map(
                                        (item) =>
                                            html` <research-filter-item
                                                id="catalog-filter-item"
                                                class="filter-item"
                                                slot="filter-item"
                                                ?checked="${this._filterSegment?.includes(item.tagName)}"
                                                label="${item.title}"
                                                value="${item.tagName}"
                                                items-count="${this._counter.segments[item.tagName] ?? 0}"
                                            >
                                            </research-filter-item>`
                                    )}
                                </research-filter>
                            ` :
                          ``}
                      ${this.devices?.length > 0 ?
                          html`
                                <research-filter
                                    active
                                    id="device-filter"
                                    class="catalog-filter"
                                    title="${this.data.catalog?.dictionary?.devicesLabel}"
                                    ._selected="${this._filterDevice}"
                                    @filter-changed="${this._handleChangedDevice}"
                                >
                                    ${this.devices.map(
                                        (item) =>
                                            html` <research-filter-item
                                                id="device-filter-item"
                                                class="filter-item"
                                                slot="filter-item"
                                                ?checked="${this._filterDevice?.includes(item.tagName)}"
                                                label="${item.title}"
                                                value="${item.tagName}"
                                                items-count="${this._counter.devices[item.tagName] ?? 0}"
                                            >
                                            </research-filter-item>`
                                    )}
                                </research-filter>
                            ` :
                          ``}
                      ${this.locations?.length > 0 ?
                          html`
                                <research-filter
                                    active
                                    id="location-filter"
                                    class="catalog-filter"
                                    title="${this.data.catalog?.dictionary?.locationsLabel}"
                                    ._selected="${this._filterLocation}"
                                    @filter-changed="${this._handleChangedLocation}"
                                >
                                    ${this.locations.map(
                                        (item) =>
                                            html` <research-filter-item
                                                id="location-filter-item"
                                                class="filter-item"
                                                slot="filter-item"
                                                ?checked="${this._filterLocation?.includes(item.tagName)}"
                                                label="${item.title}"
                                                value="${item.tagName}"
                                                items-count="${this._counter.locations[item.tagName] ?? 0}"
                                            >
                                            </research-filter-item>`
                                    )}
                                </research-filter>
                            ` :
                          ``}
                  `}
        `;
    }

    static get properties() {
        return {
            data: {
                type: Object,
            },
            isLoading: {
                type: Boolean,
            },
            filtersIsLoading: {
                type: Boolean,
            },
            _currentPage: {
                type: Number,
            },
            _pageSize: {
                type: Number,
            },
            _totalItems: {
                type: Number,
            },
            itemsToShow: {
                type: Array,
            },
            _skeletonArr: {
                type: Array,
            },
            _filterSegment: {
                type: Array,
            },
            _filterDevice: {
                type: Array,
            },
            _filterLocation: {
                type: Array,
            },
            filterSegmentStr: {
                type: String,
            },
            filterDeviceStr: {
                type: String,
            },
            filterLocationStr: {
                type: String,
            },
            sortStr: {
                type: String,
            },
            _counter: {
                type: Object,
            },
        };
    }

    constructor() {
        super();
        this.data = {};
        this.filtersIsLoading = true;
        this.isLoading = true;
        this._pageSize = 7;
        this._currentPage = 1;
        this._skeletonArr = [0, 0, 0];
        this.itemsToShow = [];
        this.filterSegmentStr = '';
        this.filterDeviceStr = '';
        this.filterLocationStr = '';
        this.sortStr = 'favourite';
        this.segments = [];
        this.devices = [];
        this.locations = [];
        this._counter = {
            segments: {},
            devices: {},
            locations: {},
        };

        this._isMobile = window.matchMedia(`(max-width: 600px)`).matches;
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
        this._isLaptop = window.matchMedia(`(max-width: 1024px)`).matches;
    }

    connectedCallback() {
        super.connectedCallback();
        if (this.ref) {
            const {$ref, $id} = this.ref;
            this.apiCall(`catalog/${$ref}/${$id}`)
                .then((res) => {
                    this.data = res.json.data;
                    this.segments = this.data?.catalog?.segments?.value || [];
                    this.devices = this.data?.catalog?.devices?.value || [];
                    this.locations = this.data?.catalog?.locations?.value || [];

                    this._checkQuery();
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }

    getCategoriesCount() {
        if (!this.data?.catalog?.cards?.collection ||
            !this.data.catalog.cards.listId) return;
        const {collection, listId} = this.data.catalog.cards;
        const params = {
            collection,
            listId,
            segments: this._getFilterValues(this.segments, true),
            devices: this._getFilterValues(this.devices, true),
            locations: this._getFilterValues(this.locations, true),
            filterSegment: this.filterSegmentStr,
            filterDevice: this.filterDeviceStr,
            filterLocation: this.filterLocationStr,
        };

        this.apiCall(`catalog/get-categories-count`, 'POST', params)
            .then((res) => {
                this._counter = res.json.data;
                this.filtersIsLoading = false;
            })
            .catch((err) => {
                console.error(err);
                this.filtersIsLoading = false;
            });
    }

    _handleChangedSegment(e, elem = this) {
        elem._filterSegment = e.detail.selected || null;

        const segments = elem._getFilterValues(elem._filterSegment);
        this.filterSegmentStr = segments;
        elem._changeUrl('segments', segments);
        this.sendAnalyticsEvent({
            eventName: 'Research_Bog',
            eventAction: 'segment_filter_click',
            eventLabel: segments,
            isNonInteraction: false,
            sendToFB: true,
        });
    }

    _handleChangedDevice(e, elem = this) {
        elem._filterDevice = e.detail.selected || null;

        const devices = elem._getFilterValues(elem._filterDevice);
        this.filterDeviceStr = devices;
        elem._changeUrl('device', devices);

        this.sendAnalyticsEvent({
            eventName: 'Research_Bog',
            eventAction: 'device_filter_click',
            eventLabel: devices,
            isNonInteraction: false,
            sendToFB: true,
        });
    }

    _handleChangedLocation(e, elem = this) {
        elem._filterLocation = e.detail.selected || null;

        const locations = elem._getFilterValues(elem._filterLocation);
        this.filterLocationStr = locations;
        elem._changeUrl('location', locations);
        console.log('locations', locations);
        this.sendAnalyticsEvent({
            eventName: 'Research_Bog',
            eventAction: 'location_filter_click',
            eventLabel: locations,
            isNonInteraction: false,
            sendToFB: true,
        });
    }

    _getFilterValues(filters, tagName = false) {
        const names = filters.map((a) => a.tagName);
        const filterStr =
            filters && filters !== undefined && filters !== null && filters.length !== 0 ? tagName ?
                names.join(',') : filters.join(',') : null;
        return filterStr;
    }

    _handleSortValueChange(sortValue, elem = this) {
        if (sortValue) {
            this.sortStr = sortValue;
            elem._changeUrl('sortBy', this.sortStr);
        } else {
            this.sortStr = 'favourite';
            elem._changeUrl('sortBy', this.sortStr);
        }
    }

    _changeUrl(filterParamName, filterValues) {
        const url = new URL(window.location.href);
        if (filterValues) {
            url.searchParams.set(filterParamName, filterValues);
        } else {
            url.searchParams.delete(filterParamName);
        }
        url.searchParams.delete('currentPage');
        window.history.replaceState(null, null, url.toString());
        this._currentPage = 1;
        this._getResearchesData();
    }

    _checkQuery() {
        const url = new URL(window.location.href);
        const segments = url.searchParams.get('segments');
        const device = url.searchParams.get('device');
        const location = url.searchParams.get('location');
        const sortBy = url.searchParams.get('sortBy');
        this._currentPage = url.searchParams.get('currentPage') ? url.searchParams.get('currentPage') : 1;

        if (segments && segments.length > 0) {
            this._filterSegment = segments.split(',');
            this.filterSegmentStr = segments;
        }

        if (device && device.length > 0) {
            this._filterDevice = device.split(',');
            this.filterDeviceStr = device;
        }

        if (location && location.length > 0) {
            this._filterLocation = location.split(',');
            this.filterLocationStr = location;
        }

        if (sortBy && sortBy.length > 0) {
            this.sortStr = sortBy;
        }

        this._getResearchesData();
    }

    _getResearchesData() {
        this.isLoading = true;
        this._totalItems = [];
        if (!this.filterSegmentStr) {
            this.filterSegmentStr = '';
        }
        if (!this.filterDeviceStr) {
            this.filterDeviceStr = '';
        }
        if (!this.filterLocationStr) {
            this.filterLocationStr = '';
        }

        if (this.data?.catalog?.cards?.collection &&
            this.data.catalog.cards.listId) {
            this.getCategoriesCount();
            const {collection, listId} = this.data.catalog.cards;
            // eslint-disable-next-line max-len
            this.apiCall(`catalog/get-items/${collection}/${listId}?filterSegment=${this.filterSegmentStr}&filterDevice=${this.filterDeviceStr}&filterLocation=${this.filterLocationStr}&sortBy=${this.sortStr}&page=${this._currentPage - 1}&limit=${this._pageSize}`)
                .then((res) => {
                    this.itemsToShow = res.json.data.items;
                    this._totalItems = res.json.data.total;
                    this.isLoading = false;
                })
                .catch((err) => {
                    this.isLoading = false;
                    console.error(err);
                });
        }
    }

    _handlePageChange(e) {
        this.isLoading = true;
        this._currentPage = e.detail.page;
        this._getResearchesData();

        const url = new URL(window.location.href);
        url.searchParams.set('currentPage', this._currentPage);
        window.history.replaceState(null, null, url.toString());
        this._scroll();
    }

    getIcon(data, isDevice = false) {
        if (!data?.value) return '';
        const itemTag = data.value.tagName;
        if (isDevice) {
            return itemTag === 'mobile' ? 'bd:mobile_all' : 'bd:banking_internet';
        } else {
            return itemTag === 'online' ? 'bd:internet_outline' : 'bd:banking_service';
        }
    }

    _clearFilters(elem = this) {
        elem.isLoading = true;
        elem._filterSegment = [];
        elem._filterDevice = [];
        elem._filterLocation = [];
        elem._currentPage = 1;
        elem.filterSegmentStr = '';
        elem.filterDeviceStr = '';
        elem.filterLocationStr = '';
        elem._counter = {
            segments: {},
            devices: {},
            locations: {},
        };

        const url = new URL(window.location.href);
        url.searchParams.delete('segments');
        url.searchParams.delete('device');
        url.searchParams.delete('location');
        url.searchParams.delete('currentPage');
        window.history.replaceState(null, null, url.toString());

        elem._getResearchesData();
    }

    _scroll() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }

    openModal(filterModal = false, item) {
        const options = {
            element: filterModal ? this._modalContent(item) : this._infoModalContent(item),
            sticky: filterModal,
            beforeClose: null,
        };
        BdModal.open(options).catch(() => {});
    }

    _closeModal() {
        BdModal.close();
    }

    _infoModalContent(item) {
        return html`
            <research-info-modal
                .data="${this.data?.infoModal}"
                .registrationUrl="${item}"
                @close-info-modal="${this._closeModal}"
            ></research-info-modal>
        `;
    }

    _modalContent(item) {
        return html`
            <research-catalog-filter-modal
                .data="${item}"
                .segments="${this.segments}"
                ._filterSegment="${this._filterSegment}"
                .devices="${this.devices}"
                ._filterDevice="${this._filterDevice}"
                .locations="${this.locations}"
                ._filterLocation="${this._filterLocation}"
                ._counter="${this._counter}"
                @changed-filters="${(e) => this._handleChangedModalFilters(e, this)}"
                @clear-filters="${() => this._clearFilters(this)}"
                @close-info-modal="${this._closeModal}"
            ></research-catalog-filter-modal>
        `;
    }

    _handleChangedModalFilters(e, elem = this) {
        elem._filterSegment = e.detail.selectedSegment || [];
        const segments = elem._getFilterValues(elem._filterSegment);
        this.filterSegmentStr = segments;

        elem._filterDevice = e.detail.selectedDevice || [];
        const devices = elem._getFilterValues(elem._filterDevice);
        this.filterDeviceStr = devices;

        elem._filterLocation = e.detail.selectedLocation || [];
        const locations = elem._getFilterValues(elem._filterLocation);
        this.filterLocationStr = locations;

        elem._changeUrlFromModal('segments', segments, 'device', devices, 'location', locations);
    }

    _changeUrlFromModal(
        filterParamName,
        filterValues,
        secondFilterParamName,
        secondFilterValues,
        thirdFilterParamName,
        thirdFilterValues
    ) {
        const url = new URL(window.location.href);
        if (filterValues) {
            url.searchParams.set(filterParamName, filterValues);
        } else {
            url.searchParams.delete(filterParamName);
        }
        if (secondFilterValues) {
            url.searchParams.set(secondFilterParamName, secondFilterValues);
        } else {
            url.searchParams.delete(secondFilterParamName);
        }
        if (thirdFilterValues) {
            url.searchParams.set(thirdFilterParamName, thirdFilterValues);
        } else {
            url.searchParams.delete(thirdFilterParamName);
        }
        url.searchParams.delete('currentPage');
        window.history.replaceState(null, null, url.toString());
        this._currentPage = 1;
        this._getResearchesData();
    }
}

window.customElements.define(researchCatalog.is, researchCatalog);
